import { Event } from 'app/shared/typings';

export const useTicketsUnavailablePage = (event?: Event) => {
  if (!event) {
    return {};
  }

  const isOutOfStock = !!event.isSoldOut || !!event.cancelled;
  const ticketSaleStatus = isOutOfStock ? 'unavailable' : 'paused';
  const attendeeFlow = event.competition?.id ? 'apply' : event.attendeeFlow;
  const pageQaid = isOutOfStock
    ? 'event-page-tickets-unavailable'
    : attendeeFlow === 'buy'
      ? 'event-page-buy-flow-ticket-sales-paused'
      : 'event-page-apply-flow-tickets-paused';

  return {
    isOutOfStock,
    ticketSaleStatus,
    pageQaid,
  };
};
